import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import cx from 'classnames';
import { Alert as AntdAlert } from 'antd';

import classes from './Alert.module.scss';

const Alert = props => {
  const {
    className,
    children,
    description,
    customClose,
    onClose,
    ...other
  } = props;
  const descriptionNode = (
    <>
      {description}{' '}
      {customClose && (
        <button
          type="button"
          className="ant-alert-close-icon"
          tabIndex="0"
          onClick={onClose}
        >
          <span role="img" aria-label="close" className="anticon anticon-close">
            <CloseOutlined />
          </span>
        </button>
      )}
    </>
  );
  return (
    <AntdAlert
      {...other}
      onClose={onClose}
      description={descriptionNode}
      className={cx(classes.wrapper, className)}
    >
      {children}
    </AntdAlert>
  );
};

export default Alert;
